import type { MessageV2Dto } from "@/api/types";
import imgLaugh from "@/assets/images/reactions/laugh.png";
import imgLike from "@/assets/images/reactions/like.png";
import imgLove from "@/assets/images/reactions/love.png";
import imgSad from "@/assets/images/reactions/sad.png";
import imgWow from "@/assets/images/reactions/wow.png";
import type { TranslationFunction } from "@/translations";

export const getReactionImage = (reactionType: string): string | undefined => {
  switch (reactionType) {
    case "sad":
      return imgSad;
    case "wow":
      return imgWow;
    case "laugh":
      return imgLaugh;
    case "love":
      return imgLove;
    case "like":
      return imgLike;
    default:
      return undefined;
  }
};

export const getReactionLabel = (reactionType: string, t: TranslationFunction): string => {
  switch (reactionType) {
    case "sad":
      return t("component.community-post.reaction.sad.button");
    case "wow":
      return t("component.community-post.reaction.wow.button");
    case "laugh":
      return t("component.community-post.reaction.laugh.button");
    case "love":
      return t("component.community-post.reaction.love.button");
    case "like":
      return t("component.community-post.reaction.like.button");
    default:
      return "";
  }
};

export const getTotalReactionAmount = (reactionCountByType: MessageV2Dto["totalReactionCountByType"]): number => {
  return Object.values(reactionCountByType).reduce((acc, curr) => acc + curr, 0);
};
